import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const BreadcrumbNav = () => {
  const breadcrumbs = [
    { name: 'Home', path: '/homepage', icon: 'Home' },
    { name: 'Legal', path: null, icon: 'Scale' },
    { name: 'Terms & Conditions', path: '/terms-conditions', icon: 'FileText' }
  ];

  return (
    <nav className="flex items-center space-x-2 text-sm mb-6" aria-label="Breadcrumb">
      {breadcrumbs?.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <Icon name="ChevronRight" size={14} className="text-text-secondary" />
          )}
          {item?.path && index !== breadcrumbs?.length - 1 ? (
            <Link
              to={item?.path}
              className="flex items-center space-x-1 text-text-secondary hover:text-primary brand-transition"
            >
              <Icon name={item?.icon} size={14} />
              <span>{item?.name}</span>
            </Link>
          ) : (
            <span className={`flex items-center space-x-1 ${
              index === breadcrumbs?.length - 1 
                ? 'text-primary font-medium' :'text-text-secondary'
            }`}>
              <Icon name={item?.icon} size={14} />
              <span>{item?.name}</span>
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default BreadcrumbNav;